// Format a DURATION (not a clock time) as H:MM — e.g. 8.75 hours -> "8:45".
export const hoursToHM = (h) => {
  if (h == null || isNaN(h)) return "—";
  const total = Math.round(Number(h) * 60);
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  return `${hh}:${String(mm).padStart(2, "0")}`;
};

// Same, from a minutes value — e.g. 65 -> "1:05".
export const minutesToHM = (m) => {
  if (m == null || isNaN(m)) return "—";
  const total = Math.round(Number(m));
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  return `${hh}:${String(mm).padStart(2, "0")}`;
};
